/** DECIMAL(20,4) arrives as a string ("1234.5600"); JSON numbers pass through.
 *  Blank, non-numeric or non-finite input returns null so the caller decides how to show it. */
export const toMajorNumber = (value: unknown): number | null => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string' || value.trim() === '') return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};
